import { render, staticRenderFns } from "./zz.vue?vue&type=template&id=19862b29&"
import script from "./zz.vue?vue&type=script&lang=js&"
export * from "./zz.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports